// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(searchTerm, viewId) {
  return {
    searchTerm: searchTerm,
    viewId: viewId
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"":{"f":""}}};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {"__root":{"":{"f":""}}};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 7
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  }
],
v4 = [
  (v2/*: any*/)
],
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationDisplay",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/)
  ],
  "type": "PropertyLocationWithHiddenAddress",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "matchingType",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "archived",
    "storageKey": null
  }
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "ExpiredProperty",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "RentedProperty",
  "abstractKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "WithdrawnProperty",
  "abstractKey": null
},
v18 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isRenewable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "activeUntil",
    "storageKey": null
  }
],
v19 = {
  "kind": "InlineFragment",
  "selections": (v18/*: any*/),
  "type": "ActiveProperty",
  "abstractKey": null
},
v20 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "format",
        "value": "SHORT"
      }
    ],
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": "formatted(format:\"SHORT\")"
  }
],
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Price",
    "kind": "LinkedField",
    "name": "minPrice",
    "plural": false,
    "selections": (v20/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Price",
    "kind": "LinkedField",
    "name": "maxPrice",
    "plural": false,
    "selections": (v20/*: any*/),
    "storageKey": null
  }
],
v22 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "price",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isPropertyPrice"
          },
          {
            "kind": "InlineFragment",
            "selections": (v21/*: any*/),
            "type": "PriceRange",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Price",
                "kind": "LinkedField",
                "name": "price",
                "plural": false,
                "selections": (v20/*: any*/),
                "storageKey": null
              }
            ],
            "type": "ExactPrice",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "PropertyV5",
    "abstractKey": "__isPropertyV5"
  }
],
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v22/*: any*/),
      "type": "ForSalePropertyV5",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v22/*: any*/),
      "type": "RentalPropertyV5",
      "abstractKey": null
    }
  ],
  "type": "PropertyV5",
  "abstractKey": "__isPropertyV5"
},
v24 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v25 = [
  (v6/*: any*/)
],
v26 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "activityReport",
    "plural": false,
    "selections": (v25/*: any*/),
    "storageKey": null
  },
  (v7/*: any*/)
],
v27 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v6/*: any*/),
      {
        "alias": "numberOfMatches",
        "args": [
          {
            "kind": "Literal",
            "name": "dismissalState",
            "value": "UNDISMISSED"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "matches",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          }
        ],
        "storageKey": "matches(dismissalState:\"UNDISMISSED\")"
      }
    ],
    "type": "Matchable",
    "abstractKey": "__isMatchable"
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canDelete",
  "storageKey": null
},
v29 = {
  "alias": "forSalePropertyMatchingType",
  "args": null,
  "kind": "ScalarField",
  "name": "matchingType",
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v28/*: any*/),
    {
      "alias": "forSaleProperty",
      "args": null,
      "concreteType": "ForSalePropertyV5",
      "kind": "LinkedField",
      "name": "property",
      "plural": false,
      "selections": [
        (v29/*: any*/),
        (v8/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    (v28/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RentalPropertyV5",
      "kind": "LinkedField",
      "name": "property",
      "plural": false,
      "selections": [
        {
          "alias": "rentalPropertyMatchingType",
          "args": null,
          "kind": "ScalarField",
          "name": "matchingType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Landlord",
  "abstractKey": null
},
v32 = [
  (v13/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/)
],
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v28/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RentalNeedV5",
      "kind": "LinkedField",
      "name": "rentalNeed",
      "plural": false,
      "selections": (v32/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Renter",
  "abstractKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/),
    (v31/*: any*/),
    (v33/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v28/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BuyerNeedV5",
          "kind": "LinkedField",
          "name": "buyerNeed",
          "plural": false,
          "selections": (v32/*: any*/),
          "storageKey": null
        }
      ],
      "type": "Buyer",
      "abstractKey": null
    }
  ],
  "type": "ClientV5",
  "abstractKey": "__isClientV5"
},
v35 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "SoldProperty",
  "abstractKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "UnderContractProperty",
  "abstractKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "PriceRange",
  "kind": "LinkedField",
  "name": "priceRange",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v39 = [
  (v38/*: any*/),
  (v7/*: any*/)
],
v40 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Area",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v39/*: any*/),
    "storageKey": null
  }
],
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v28/*: any*/)
  ],
  "type": "Buyer",
  "abstractKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v45 = {
  "kind": "Variable",
  "name": "__dynamicKey",
  "variableName": "viewId"
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v47 = [
  (v6/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MyDashboardPageRelayQuery",
    "selections": [
      {
        "kind": "Defer",
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "FragmentSpread",
            "name": "MyClientsWidgetRelay_query"
          }
        ]
      },
      {
        "kind": "Defer",
        "selections": [
          {
            "args": (v4/*: any*/),
            "kind": "FragmentSpread",
            "name": "MyDraftsWidgetDraftList_query"
          }
        ]
      },
      {
        "kind": "Defer",
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "FragmentSpread",
            "name": "MyBroadcastMessagesWidgetList_query"
          }
        ]
      },
      {
        "kind": "Defer",
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "FragmentSpread",
            "name": "MySharedPostsWidgetList_query"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MyDashboardPageRelayQuery",
    "selections": [
      {
        "if": null,
        "kind": "Defer",
        "label": "MyDashboardPageRelayQuery$defer$MyClientsWidgetRelay_query_4DsUgm",
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "QueryClientV5Connection",
            "kind": "LinkedField",
            "name": "accountClientsV5",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueryClientV5Edge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RentalPropertyV5",
                            "kind": "LinkedField",
                            "name": "property",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "propertyLocation",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/)
                                    ],
                                    "type": "PropertyLocationWithVisibleAddress",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v23/*: any*/),
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetLandlord_Menu_landlord$defer$MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v24/*: any*/),
                                    "concreteType": "RentalPropertyBroadcastConnection",
                                    "kind": "LinkedField",
                                    "name": "broadcasts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalPropertyBroadcastEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalPropertyBroadcast",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v26/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "broadcasts(first:1)"
                                  }
                                ]
                              },
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetLandlord_rowDetails_landlord$defer$MyClientsWidgetComponentsMatchesSummary_matchable",
                                "selections": (v27/*: any*/)
                              }
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/)
                        ],
                        "type": "Landlord",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ForSalePropertyV5",
                            "kind": "LinkedField",
                            "name": "property",
                            "plural": false,
                            "selections": [
                              (v29/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "anonymousProperty",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "propertyLocation",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "visibilityRule",
                                        "storageKey": null
                                      },
                                      (v12/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "type": "PropertyLocationWithVisibleAddress",
                                    "abstractKey": null
                                  },
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v19/*: any*/),
                                  (v15/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": "forSaleMatchingType",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "matchingType",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v15/*: any*/),
                                  (v35/*: any*/),
                                  (v36/*: any*/),
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v23/*: any*/),
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetSeller_Menu_seller$defer$MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v24/*: any*/),
                                    "concreteType": "PropertyBroadcastConnection",
                                    "kind": "LinkedField",
                                    "name": "broadcasts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PropertyBroadcastEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ForSalePropertyBroadcast",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v26/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "broadcasts(first:1)"
                                  }
                                ]
                              },
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetSeller_rowDetails_seller$defer$MyClientsWidgetComponentsMatchesSummary_matchable",
                                "selections": (v27/*: any*/)
                              }
                            ],
                            "storageKey": null
                          },
                          (v34/*: any*/)
                        ],
                        "type": "Seller",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClientContactsConnection",
                            "kind": "LinkedField",
                            "name": "contacts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ClientContactsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ClientContactV5",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "clientAccessStatus",
                                        "plural": false,
                                        "selections": (v25/*: any*/),
                                        "storageKey": null
                                      },
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BuyerNeedV5",
                            "kind": "LinkedField",
                            "name": "buyerNeed",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "autoNotify",
                                "storageKey": null
                              },
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BuyerNeedAreaConnection",
                                "kind": "LinkedField",
                                "name": "areas",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BuyerNeedAreaEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": (v40/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v18/*: any*/),
                                    "type": "ActiveBuyerNeed",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "alias": "buyerNeedMatchingType",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "matchingType",
                                "storageKey": null
                              },
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetBuyer_Menu_buyer$defer$MyClientsWidgetBuyer_Menu_ActivityReportMenuItem_buyerNeed",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v24/*: any*/),
                                    "concreteType": "BuyerNeedBroadcastConnection",
                                    "kind": "LinkedField",
                                    "name": "broadcasts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BuyerNeedBroadcastEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "BuyerNeedBroadcast",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v26/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "broadcasts(first:1)"
                                  }
                                ]
                              },
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetBuyer_rowDetails_buyer$defer$MyClientsWidgetComponentsMatchesSummary_matchable",
                                "selections": (v27/*: any*/)
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              (v31/*: any*/),
                              (v33/*: any*/),
                              (v41/*: any*/)
                            ],
                            "type": "ClientV5",
                            "abstractKey": "__isClientV5"
                          }
                        ],
                        "type": "Buyer",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RentalNeedV5",
                            "kind": "LinkedField",
                            "name": "rentalNeed",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RentalNeedAreaConnection",
                                "kind": "LinkedField",
                                "name": "areas",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalNeedAreaEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": (v40/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v18/*: any*/),
                                    "type": "ActiveRentalNeed",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v8/*: any*/),
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetRenter_Menu_renter$defer$MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed",
                                "selections": [
                                  (v8/*: any*/),
                                  {
                                    "alias": null,
                                    "args": (v24/*: any*/),
                                    "concreteType": "RentalNeedBroadcastConnection",
                                    "kind": "LinkedField",
                                    "name": "broadcasts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RentalNeedBroadcastEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RentalNeedBroadcast",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v26/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "broadcasts(first:1)"
                                  }
                                ]
                              },
                              {
                                "if": null,
                                "kind": "Defer",
                                "label": "MyClientsWidgetRenter_rowDetails_renter$defer$MyClientsWidgetComponentsMatchesSummary_matchable",
                                "selections": (v27/*: any*/)
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v30/*: any*/),
                              (v31/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RentalNeedV5",
                                    "kind": "LinkedField",
                                    "name": "rentalNeed",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Renter",
                                "abstractKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "type": "ClientV5",
                            "abstractKey": "__isClientV5"
                          }
                        ],
                        "type": "Renter",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/),
              (v44/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "filters": [
              "searchTerm"
            ],
            "handle": "connection",
            "key": "MyClientsWidgetRelayQuery_accountClientsV5",
            "kind": "LinkedHandle",
            "name": "accountClientsV5",
            "dynamicKey": (v45/*: any*/)
          }
        ]
      },
      {
        "if": null,
        "kind": "Defer",
        "label": "MyDashboardPageRelayQuery$defer$MyDraftsWidgetDraftList_query_1752XP",
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "QueryDraftsForCurrentAccountV5Connection",
            "kind": "LinkedField",
            "name": "draftsForCurrentAccountV5",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueryDraftsForCurrentAccountV5ConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DraftV5",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "origin",
                        "storageKey": null
                      },
                      (v46/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "publishedProperty",
                        "plural": false,
                        "selections": (v47/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DraftPropertyV5",
                        "kind": "LinkedField",
                        "name": "draftProperty",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Area",
                            "kind": "LinkedField",
                            "name": "userSelectedArea",
                            "plural": false,
                            "selections": (v39/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/),
              (v44/*: any*/)
            ],
            "storageKey": "draftsForCurrentAccountV5(first:7)"
          },
          {
            "alias": null,
            "args": (v4/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "MyDraftsWidgetDraftList_query_draftsForCurrentAccountV5",
            "kind": "LinkedHandle",
            "name": "draftsForCurrentAccountV5",
            "dynamicKey": (v45/*: any*/)
          }
        ]
      },
      {
        "if": null,
        "kind": "Defer",
        "label": "MyDashboardPageRelayQuery$defer$MyBroadcastMessagesWidgetList_query_3OVASn",
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "QueryMessageBroadcastsForCurrentUserConnection",
            "kind": "LinkedField",
            "name": "messageBroadcastsForCurrentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueryMessageBroadcastsForCurrentUserConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageBroadcast",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CategoryV5",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subject",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "broadcastAt",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/),
              (v44/*: any*/)
            ],
            "storageKey": "messageBroadcastsForCurrentUser(first:5)"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "MyBroadcastMessagesWidgetList_query_messageBroadcastsForCurrentUser",
            "kind": "LinkedHandle",
            "name": "messageBroadcastsForCurrentUser",
            "dynamicKey": (v45/*: any*/)
          }
        ]
      },
      {
        "if": null,
        "kind": "Defer",
        "label": "MyDashboardPageRelayQuery$defer$MySharedPostsWidgetList_query_3OVASn",
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "QuerySharedPostsForCurrentUserV5Connection",
            "kind": "LinkedField",
            "name": "sharedPostsForCurrentUserV5",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QuerySharedPostsForCurrentUserV5ConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v46/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "propertyLocation",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v12/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "type": "PropertyLocationWithVisibleAddress",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 20
                              }
                            ],
                            "concreteType": "SharedPropertyV5ContactsConnection",
                            "kind": "LinkedField",
                            "name": "contacts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SharedPropertyV5ContactsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v46/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "firstName",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "lastName",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "SharingContactClientContactV5",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v46/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "email",
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "SharingContactFreshContactV5",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "contacts(first:20)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "property",
                            "plural": false,
                            "selections": (v47/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "SharedPropertyV5",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              (v43/*: any*/)
            ],
            "storageKey": "sharedPostsForCurrentUserV5(first:5)"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "MySharedPostsList_query_sharedPostsForCurrentUserV5",
            "kind": "LinkedHandle",
            "name": "sharedPostsForCurrentUserV5",
            "dynamicKey": (v45/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "75ebf05064b35b947272741e54a3fed2",
    "id": null,
    "metadata": {},
    "name": "MyDashboardPageRelayQuery",
    "operationKind": "query",
    "text": "query MyDashboardPageRelayQuery(\n  $searchTerm: String\n) {\n  ...MyClientsWidgetRelay_query_4DsUgm @defer(label: \"MyDashboardPageRelayQuery$defer$MyClientsWidgetRelay_query_4DsUgm\")\n  ...MyDraftsWidgetDraftList_query_1752XP @defer(label: \"MyDashboardPageRelayQuery$defer$MyDraftsWidgetDraftList_query_1752XP\")\n  ...MyBroadcastMessagesWidgetList_query_3OVASn @defer(label: \"MyDashboardPageRelayQuery$defer$MyBroadcastMessagesWidgetList_query_3OVASn\")\n  ...MySharedPostsWidgetList_query_3OVASn @defer(label: \"MyDashboardPageRelayQuery$defer$MySharedPostsWidgetList_query_3OVASn\")\n}\n\nfragment BuyerNeedPriceRange_buyerNeedV5 on BuyerNeedV5 {\n  priceRange {\n    ...PriceRangeCriteria_priceRange\n  }\n}\n\nfragment ForSalePropertyTypeDisplayName_property on ForSalePropertyV5 {\n  forSalePropertyMatchingType: matchingType\n  anonymousProperty\n}\n\nfragment MyBroadcastMessagesWidgetListItem_message on MessageBroadcast {\n  id\n  category {\n    name\n  }\n  subject\n  broadcastAt\n}\n\nfragment MyBroadcastMessagesWidgetList_query_3OVASn on Query {\n  messageBroadcastsForCurrentUser(first: 5) {\n    edges {\n      node {\n        nodeId\n        ...MyBroadcastMessagesWidgetListItem_message\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MyClientsWidgetBuyer_Menu_ActivityReportMenuItem_buyerNeed on BuyerNeedV5 {\n  id\n  broadcasts(first: 1) {\n    edges {\n      node {\n        activityReport {\n          __typename\n          ... on ActivityReportV5 {\n            __typename\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment MyClientsWidgetBuyer_Menu_buyer on Buyer {\n  id\n  buyerNeed {\n    id\n    nodeId\n    buyerNeedMatchingType: matchingType\n    status {\n      __typename\n      ... on ActiveBuyerNeed {\n        isRenewable\n      }\n      ... on ExpiredBuyerNeed {\n        __typename\n      }\n      ... on InContractBuyerNeed {\n        __typename\n      }\n      ... on PurchasedBuyerNeed {\n        __typename\n      }\n      ... on WithdrawnBuyerNeed {\n        __typename\n      }\n    }\n    ...MyClientsWidgetBuyer_Menu_ActivityReportMenuItem_buyerNeed @defer(label: \"MyClientsWidgetBuyer_Menu_buyer$defer$MyClientsWidgetBuyer_Menu_ActivityReportMenuItem_buyerNeed\")\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetBuyer_buyer on Buyer {\n  ...MyClientsWidgetBuyer_name_buyer\n  ...MyClientsWidgetBuyer_status_buyer\n  ...MyClientsWidgetBuyer_Menu_buyer\n  ...MyClientsWidgetBuyer_rowDetails_buyer\n}\n\nfragment MyClientsWidgetBuyer_name_buyer on Buyer {\n  id\n  displayName\n  contacts {\n    edges {\n      node {\n        clientAccessStatus {\n          __typename\n          ... on ClientContactInvited {\n            __typename\n          }\n          ... on ClientContactRegistered {\n            __typename\n          }\n        }\n        nodeId\n      }\n    }\n  }\n  buyerNeed {\n    matchingType\n    autoNotify\n    ...BuyerNeedPriceRange_buyerNeedV5\n    areas {\n      edges {\n        node {\n          name\n          nodeId\n        }\n      }\n    }\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetBuyer_rowDetails_buyer on Buyer {\n  id\n  buyerNeed {\n    ...MyClientsWidgetComponentsMatchesSummary_matchable @defer(label: \"MyClientsWidgetBuyer_rowDetails_buyer$defer$MyClientsWidgetComponentsMatchesSummary_matchable\")\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetBuyer_status_buyer on Buyer {\n  buyerNeed {\n    ...OwnBuyerNeedStatusLabel_buyerNeedV5\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetComponentsMatchesSummary_matchable on Matchable {\n  __isMatchable: __typename\n  __typename\n  numberOfMatches: matches(dismissalState: UNDISMISSED) {\n    __typename\n    totalCount\n  }\n}\n\nfragment MyClientsWidgetDeleteDialog_clientV5 on ClientV5 {\n  __isClientV5: __typename\n  __typename\n  ... on Seller {\n    canDelete\n    forSaleProperty: property {\n      forSalePropertyMatchingType: matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Landlord {\n    canDelete\n    property {\n      rentalPropertyMatchingType: matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Renter {\n    canDelete\n    rentalNeed {\n      matchingType\n      id\n      nodeId\n    }\n  }\n  ... on Buyer {\n    canDelete\n    buyerNeed {\n      matchingType\n      id\n      nodeId\n    }\n  }\n}\n\nfragment MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property on RentalPropertyV5 {\n  id\n  broadcasts(first: 1) {\n    edges {\n      node {\n        activityReport {\n          __typename\n          ... on ActivityReportV5 {\n            __typename\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment MyClientsWidgetLandlord_Menu_landlord on Landlord {\n  id\n  property {\n    id\n    nodeId\n    status {\n      __typename\n      ... on ExpiredProperty {\n        archived\n      }\n      ... on RentedProperty {\n        archived\n      }\n      ... on WithdrawnProperty {\n        archived\n      }\n      ... on ActiveProperty {\n        isRenewable\n      }\n    }\n    ...MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property @defer(label: \"MyClientsWidgetLandlord_Menu_landlord$defer$MyClientsWidgetLandlord_Menu_ActivityReportMenuItem_property\")\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetLandlord_landlord on Landlord {\n  ...MyClientsWidgetLandlord_name_landlord\n  ...MyClientsWidgetLandlord_Menu_landlord\n  ...MyClientsWidgetLandlord_status_landlord\n  ...MyClientsWidgetLandlord_rowDetails_landlord\n}\n\nfragment MyClientsWidgetLandlord_name_landlord on Landlord {\n  displayName\n  id\n  property {\n    ...PropertyPrice_property_1b9sQ8\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n        __typename\n      }\n      ... on PropertyLocationWithVisibleAddress {\n        address\n      }\n    }\n    matchingType\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetLandlord_rowDetails_landlord on Landlord {\n  id\n  property {\n    ...MyClientsWidgetComponentsMatchesSummary_matchable @defer(label: \"MyClientsWidgetLandlord_rowDetails_landlord$defer$MyClientsWidgetComponentsMatchesSummary_matchable\")\n    status {\n      __typename\n      ... on ActiveProperty {\n        __typename\n      }\n      ... on ExpiredProperty {\n        archived\n      }\n      ... on RentedProperty {\n        archived\n      }\n      ... on WithdrawnProperty {\n        archived\n      }\n      ... on RemovedProperty {\n        __typename\n      }\n    }\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetLandlord_status_landlord on Landlord {\n  property {\n    ...OwnRentalPropertyStatusLabel_rentalPropertyV5\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetRelay_query_4DsUgm on Query {\n  accountClientsV5(first: 7, searchTerm: $searchTerm) {\n    edges {\n      node {\n        __typename\n        ... on Landlord {\n          id\n          ...MyClientsWidgetLandlord_landlord\n        }\n        ... on Seller {\n          id\n          ...MyClientsWidgetSeller_seller\n        }\n        ... on Buyer {\n          id\n          ...MyClientsWidgetBuyer_buyer\n        }\n        ... on Renter {\n          id\n          ...MyClientsWidgetRenter_renter\n        }\n        nodeId\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed on RentalNeedV5 {\n  id\n  broadcasts(first: 1) {\n    edges {\n      node {\n        activityReport {\n          __typename\n          ... on ActivityReportV5 {\n            __typename\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment MyClientsWidgetRenter_Menu_renter on Renter {\n  id\n  rentalNeed {\n    id\n    nodeId\n    status {\n      __typename\n      ... on ActiveRentalNeed {\n        isRenewable\n      }\n      ... on ExpiredRentalNeed {\n        __typename\n      }\n      ... on RentedRentalNeed {\n        __typename\n      }\n      ... on WithdrawnRentalNeed {\n        __typename\n      }\n    }\n    ...MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed @defer(label: \"MyClientsWidgetRenter_Menu_renter$defer$MyClientsWidgetRenter_Menu_ActivityReportMenuItem_rentalNeed\")\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetRenter_name_renter on Renter {\n  id\n  displayName\n  rentalNeed {\n    ...RentalNeedPriceRange_rentalNeedV5\n    areas {\n      edges {\n        node {\n          name\n          nodeId\n        }\n      }\n    }\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetRenter_renter on Renter {\n  ...MyClientsWidgetRenter_name_renter\n  ...MyClientsWidgetRenter_status_renter\n  ...MyClientsWidgetRenter_Menu_renter\n  ...MyClientsWidgetRenter_rowDetails_renter\n}\n\nfragment MyClientsWidgetRenter_rowDetails_renter on Renter {\n  id\n  rentalNeed {\n    ...MyClientsWidgetComponentsMatchesSummary_matchable @defer(label: \"MyClientsWidgetRenter_rowDetails_renter$defer$MyClientsWidgetComponentsMatchesSummary_matchable\")\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetRenter_status_renter on Renter {\n  rentalNeed {\n    ...OwnRentalNeedStatusLabel_rentalNeedV5\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property on ForSalePropertyV5 {\n  id\n  broadcasts(first: 1) {\n    edges {\n      node {\n        activityReport {\n          __typename\n          ... on ActivityReportV5 {\n            __typename\n          }\n        }\n        nodeId\n      }\n    }\n  }\n}\n\nfragment MyClientsWidgetSeller_Menu_seller on Seller {\n  id\n  property {\n    id\n    nodeId\n    forSaleMatchingType: matchingType\n    status {\n      __typename\n      ... on ExpiredProperty {\n        archived\n      }\n      ... on ActiveProperty {\n        isRenewable\n      }\n      ... on SoldProperty {\n        archived\n      }\n      ... on UnderContractProperty {\n        archived\n      }\n      ... on WithdrawnProperty {\n        archived\n      }\n    }\n    ...MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property @defer(label: \"MyClientsWidgetSeller_Menu_seller$defer$MyClientsWidgetSeller_Menu_ActivityReportMenuItem_property\")\n  }\n  ...MyClientsWidgetDeleteDialog_clientV5\n}\n\nfragment MyClientsWidgetSeller_name_seller on Seller {\n  displayName\n  id\n  property {\n    ...ForSalePropertyTypeDisplayName_property\n    ...PropertyPrice_property_1b9sQ8\n    propertyLocation {\n      __typename\n      ... on PropertyLocationWithVisibleAddress {\n        visibilityRule\n        address\n        locationDisplay\n      }\n      ... on PropertyLocationWithHiddenAddress {\n        locationDisplay\n      }\n    }\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetSeller_rowDetails_seller on Seller {\n  id\n  property {\n    ...MyClientsWidgetComponentsMatchesSummary_matchable @defer(label: \"MyClientsWidgetSeller_rowDetails_seller$defer$MyClientsWidgetComponentsMatchesSummary_matchable\")\n    status {\n      __typename\n      ... on ActiveProperty {\n        __typename\n      }\n      ... on ExpiredProperty {\n        archived\n      }\n      ... on SoldProperty {\n        archived\n      }\n      ... on UnderContractProperty {\n        archived\n      }\n      ... on WithdrawnProperty {\n        archived\n      }\n      ... on RemovedProperty {\n        __typename\n      }\n    }\n    nodeId\n  }\n}\n\nfragment MyClientsWidgetSeller_seller on Seller {\n  ...MyClientsWidgetSeller_name_seller\n  ...MyClientsWidgetSeller_status_seller\n  ...MyClientsWidgetSeller_Menu_seller\n  ...MyClientsWidgetSeller_rowDetails_seller\n}\n\nfragment MyClientsWidgetSeller_status_seller on Seller {\n  property {\n    ...OwnForSalePropertyStatusLabel_forSalePropertyV5\n    nodeId\n  }\n}\n\nfragment MyDraftsWidgetDraftListItem_draft on DraftV5 {\n  origin\n  databaseId\n  updatedAt\n  publishedProperty {\n    __typename\n    id\n    nodeId\n  }\n  draftProperty {\n    address\n    userSelectedArea {\n      name\n      nodeId\n    }\n  }\n}\n\nfragment MyDraftsWidgetDraftList_query_1752XP on Query {\n  draftsForCurrentAccountV5(first: 7) {\n    edges {\n      node {\n        nodeId\n        ...MyDraftsWidgetDraftListItem_draft\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MySharedPostsWidgetListItemSharedProperty_sharedProperty on SharedPropertyV5 {\n  databaseId\n  propertyLocation {\n    __typename\n    ... on PropertyLocationWithHiddenAddress {\n      locationDisplay\n    }\n    ... on PropertyLocationWithVisibleAddress {\n      address\n      locationDisplay\n    }\n  }\n  contacts(first: 20) {\n    edges {\n      node {\n        __typename\n        ... on SharingContactClientContactV5 {\n          databaseId\n          firstName\n          lastName\n        }\n        ... on SharingContactFreshContactV5 {\n          databaseId\n          email\n        }\n      }\n    }\n  }\n  createdAt\n  property {\n    __typename\n    id\n    nodeId\n  }\n}\n\nfragment MySharedPostsWidgetList_query_3OVASn on Query {\n  sharedPostsForCurrentUserV5(first: 5) {\n    edges {\n      node {\n        __typename\n        ... on SharedPropertyV5 {\n          databaseId\n          ...MySharedPostsWidgetListItemSharedProperty_sharedProperty\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment OwnBuyerNeedStatusLabel_buyerNeedV5 on BuyerNeedV5 {\n  status {\n    __typename\n    ... on ActiveBuyerNeed {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredBuyerNeed {\n      __typename\n    }\n    ... on PurchasedBuyerNeed {\n      __typename\n    }\n    ... on InContractBuyerNeed {\n      __typename\n    }\n    ... on WithdrawnBuyerNeed {\n      __typename\n    }\n  }\n}\n\nfragment OwnForSalePropertyStatusLabel_forSalePropertyV5 on ForSalePropertyV5 {\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredProperty {\n      __typename\n      archived\n    }\n    ... on SoldProperty {\n      __typename\n      archived\n    }\n    ... on UnderContractProperty {\n      __typename\n      archived\n    }\n    ... on WithdrawnProperty {\n      __typename\n      archived\n    }\n  }\n}\n\nfragment OwnRentalNeedStatusLabel_rentalNeedV5 on RentalNeedV5 {\n  status {\n    __typename\n    ... on ActiveRentalNeed {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredRentalNeed {\n      __typename\n    }\n    ... on RentedRentalNeed {\n      __typename\n    }\n    ... on WithdrawnRentalNeed {\n      __typename\n    }\n  }\n}\n\nfragment OwnRentalPropertyStatusLabel_rentalPropertyV5 on RentalPropertyV5 {\n  status {\n    __typename\n    ... on ActiveProperty {\n      isRenewable\n      activeUntil\n    }\n    ... on ExpiredProperty {\n      archived\n    }\n    ... on RentedProperty {\n      archived\n    }\n    ... on WithdrawnProperty {\n      archived\n    }\n  }\n}\n\nfragment PriceRangeCriteria_priceRange on PriceRange {\n  minPrice {\n    formatted(format: SHORT)\n  }\n  maxPrice {\n    formatted(format: SHORT)\n  }\n}\n\nfragment PropertyPrice_price_1b9sQ8 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  price {\n    __typename\n    ...PropertyPrice_propertyPrice_1b9sQ8\n  }\n}\n\nfragment PropertyPrice_propertyPrice_1b9sQ8 on PropertyPrice {\n  __isPropertyPrice: __typename\n  __typename\n  ... on PriceRange {\n    minPrice {\n      formatted(format: SHORT)\n    }\n    maxPrice {\n      formatted(format: SHORT)\n    }\n  }\n  ... on ExactPrice {\n    price {\n      formatted(format: SHORT)\n    }\n  }\n}\n\nfragment PropertyPrice_property_1b9sQ8 on PropertyV5 {\n  __isPropertyV5: __typename\n  __typename\n  ... on ForSalePropertyV5 {\n    ...PropertyPrice_price_1b9sQ8\n  }\n  ... on RentalPropertyV5 {\n    ...PropertyPrice_price_1b9sQ8\n  }\n}\n\nfragment RentalNeedPriceRange_rentalNeedV5 on RentalNeedV5 {\n  priceRange {\n    ...PriceRangeCriteria_priceRange\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
